import { AskNobiButton } from "@/components/AskNobi/AskNobiButton";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { DocumentPage } from "@/components/Page/DocumentPage";
import { PageGrid } from "@/components/PageGrid/PageGrid";
import { canAccessAnalytics } from "@/components/ProjectSidebar/permissions";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { useSessionUser } from "@/hooks/Network/useSessionUser";
import { usePermission } from "@/hooks/usePermission";
import { useConfig } from "@/providers/config/useConfig";
import { useTranslation } from "@/translations";

import { Analytics_LEGACY } from "./components/analytics";
import { HomeCommunityPostList } from "./components/HomeCommunityPostList";
import { HomeFahFollowUpSuggestionWidget } from "./components/HomeFahSuggestionWidget";

export function LegacyProjectHomeContent(): React.ReactNode {
  const projectId = useProjectId();
  const sessionUser = useSessionUser();
  const isAnalyticsV2Row1Available = useConfig("isAnalyticsV2Row1Available");
  const isAnalyticsV2Row2Available = useConfig("isAnalyticsV2Row2Available");
  const isAnalyticsV2Row3Available = useConfig("isAnalyticsV2Row3Available");
  const hasPermission = usePermission();
  const { t } = useTranslation();

  const isCompanyBased = sessionUser.project.type === "companyBased";
  const canViewFahWidget = sessionUser.isAdmin;

  return (
    <DocumentPage
      containerBoundary="inherit"
      tabTitle={sessionUser.project.name}
      breadcrumbs={
        <Breadcrumbs
          pages={[
            {
              name: sessionUser.project.name,
            },
            {
              name: t("page.home.title"),
            },
          ]}
        />
      }
      actions={
        <AskNobiButton
          defaultFilters={{ projectIds: [projectId] }}
          context={{ scope: "project", entity: "home", page: "detail" }}
          suggestions={[
            t("component.ask-nobi-chat-drawer.home.suggestion.1"),
            t("component.ask-nobi-chat-drawer.home.suggestion.2"),
          ]}
        />
      }
    >
      <PageGrid.Row>
        {canViewFahWidget && !isCompanyBased && (
          <>
            {/* Row 1 */}
            {isAnalyticsV2Row1Available && (
              <PageGrid.Column size="100%" isDesktopIndifferent>
                <Analytics_LEGACY.FahWidget />
              </PageGrid.Column>
            )}

            {/* Row 2 */}
            {isAnalyticsV2Row2Available && (
              <>
                <PageGrid.Column size="66%" isDesktopIndifferent>
                  <HomeFahFollowUpSuggestionWidget />
                </PageGrid.Column>
                <PageGrid.Column size="33%" isDesktopIndifferent>
                  <Analytics_LEGACY.CommunityFeedInsightsWidget />
                </PageGrid.Column>
              </>
            )}
          </>
        )}

        {/* Row 3 */}
        {isAnalyticsV2Row3Available && hasPermission(canAccessAnalytics) && (
          <>
            <PageGrid.Column size="33%">
              {sessionUser.project.type === "companyBased" ? (
                <Analytics_LEGACY.CompanyAdoptionWidget />
              ) : (
                <Analytics_LEGACY.AdoptionWidget />
              )}
            </PageGrid.Column>
            <PageGrid.Column size="33%">
              <Analytics_LEGACY.EngagementWidget />
            </PageGrid.Column>
            <PageGrid.Column size="33%">
              <Analytics_LEGACY.SocialContributionWidget />
            </PageGrid.Column>
          </>
        )}

        {/* Row 4 */}
        <PageGrid.Column size="100%" isDesktopIndifferent>
          <PageGrid.Row>
            <PageGrid.Column size="66%" isDesktopIndifferent>
              <HomeCommunityPostList />
            </PageGrid.Column>
          </PageGrid.Row>
        </PageGrid.Column>
      </PageGrid.Row>
    </DocumentPage>
  );
}
